import { AppState } from "../reducer";

export const selectAnnualFinals = (state: AppState) => state.annualFinals.standings;
